import { render } from "./PricingProfileInfoModal.vue?vue&type=template&id=ea3f3f48"
import script from "./PricingProfileInfoModal.vue?vue&type=script&lang=js"
export * from "./PricingProfileInfoModal.vue?vue&type=script&lang=js"
script.render = render

export default script